import actionTypes from '../constants/action-types';

const globalHTML = (state = {}, action) => {
  if (
    action.type !== actionTypes.SET_GLOBAL_HTML &&
    action.type !== actionTypes.SET_GLOBAL_HTML_AND_AFFECT_HISTORY
  )
    return state;
  if (state.id !== action.payload.globalId) return state;

  return {
    ...state,
    html: action.payload.html,
  };
};

export default globalHTML;
